"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _PasswordForgotten = _interopRequireDefault(require("../../components/PasswordForgotten/PasswordForgotten"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PasswordForgottenPage = /*#__PURE__*/function (_React$Component) {
  function PasswordForgottenPage(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PasswordForgottenPage);
    _this = _callSuper(this, PasswordForgottenPage, [props]);
    _this.state = {
      loading: false
    };
    return _this;
  }
  (0, _inherits2.default)(PasswordForgottenPage, _React$Component);
  return (0, _createClass2.default)(PasswordForgottenPage, [{
    key: "render",
    value: function render() {
      var loading = this.state.loading;
      return /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Loader, {
        loading: loading,
        fallbackGifSrc: localStorage.fallbackLoader
      }, /*#__PURE__*/_react.default.createElement(_PasswordForgotten.default, this.props));
    }
  }]);
}(_react.default.Component);
var _default = exports.default = PasswordForgottenPage;